<template>
  <zm-banner type="warning" class="max-phone-number__alert">
    <p>{{ $t('billing.pbx.max_phone_number_desc', [maxSelectPhoneNumbers]) }}</p>
  </zm-banner>
</template>

<script>
import { maxSelectPhoneNumbers } from '@/plans/ZOOM_PHONE/helper/constants';

export default {
  name: 'MaxPhoneNumberWarning',
  props: {
    maxSelectPhoneNumbers: {
      type: Number,
      default: maxSelectPhoneNumbers,
    }
  }
};
</script>

<style lang="scss">
.max-phone-number {
  &__alert {
    p {
      font-size: 14px;
      text-align: left;
    }
  }
}
</style>
